import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=39d19126&scoped=true"
import script from "./Verification.vue?vue&type=script&lang=js"
export * from "./Verification.vue?vue&type=script&lang=js"
import style0 from "./Verification.vue?vue&type=style&index=0&id=39d19126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d19126",
  null
  
)

export default component.exports